import type { TrainingActivity, TrainingActivityProofFile } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<TrainingActivity>('/training-activities/:id', {
  proofFiles: getHelper<TrainingActivityProofFile>('/proof-files/:id'),
});
